<template>
    <v-snackbar
    :color="color"
        @input="$emit('input', $event)" 
        :value="value"
    >
        {{ text }}

        <template v-slot:action="{ attrs }">

            <v-btn
            class="ps-5"
            color="black"
            text
            v-bind="attrs"
            @click="$emit('update:value', false)"
            >
                {{$t("CLOSE")}}
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    props: {
        value:Boolean,
        text:String,
        color:String
    }
}
</script>

<style>

</style>
